import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Phone, MessageCircle, CheckCircle } from "lucide-react";

const servicesData = {
  "lazer-epilasyon": {
    title: "Lazer Epilasyon",
    seoTitle: "Bursa Lazer Epilasyon | Purevia Güzellik",
    heroImage: "https://images.unsplash.com/photo-1700760933941-3a06a28fbf47?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Bursa'da profesyonel lazer epilasyon hizmeti ile kalıcı pürüzsüzlüğe kavuşun. Son teknoloji cihazlarımızla acısız ve etkili sonuçlar elde edin.",
    longDescription: "Purevia Güzellik olarak Bursa ve Görükle bölgesinde en son teknoloji lazer epilasyon cihazlarıyla hizmet vermekteyiz. FDA onaylı cihazlarımız, tüm cilt tiplerine uygun güvenli ve etkili sonuçlar sunar. Deneyimli uzman kadromuz, her müşterimize özel tedavi planı oluşturarak en iyi sonuçları garanti eder.",
    benefits: [
      "Son teknoloji FDA onaylı lazer cihazları",
      "Tüm cilt tiplerine uygun güvenli uygulama",
      "Acısız ve konforlu seans deneyimi",
      "Kalıcı ve etkili sonuçlar",
      "Uzman ve sertifikalı personel",
      "Hijyenik ve steril ortam",
    ],
    areas: ["Yüz", "Koltuk Altı", "Bikini", "Bacak", "Kol", "Sırt", "Tüm Vücut"],
  },
  "cilt-bakimi": {
    title: "Cilt Bakımı",
    seoTitle: "Bursa Profesyonel Cilt Bakımı | Purevia Güzellik",
    heroImage: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Profesyonel cilt bakım protokolleri ile cildinize yenileme, parlaklık ve gençlik kazandırın. Bursa'nın en iyi cilt bakım merkezi.",
    longDescription: "Cildinizin ihtiyaçlarına özel hazırlanmış profesyonel bakım protokollerimizle, derinlemesine temizlik, nemlendirme ve yenileme sağlıyoruz. Medikal ve kozmetik cilt bakım uygulamalarımız, cilt yaşlanmasını yavaşlatır ve cildinize doğal parlaklığını geri kazandırır.",
    benefits: [
      "Kişiye özel cilt analizi ve bakım planı",
      "Medikal ve kozmetik bakım protokolleri",
      "Cilt yenileme ve anti-aging uygulamalar",
      "Leke ve ton eşitsizliği tedavisi",
      "Derinlemesine temizlik ve nemlendirme",
      "Premium bakım ürünleri kullanımı",
    ],
    areas: ["Hydrafacial", "Cilt Yenileme", "Anti-Aging", "Leke Tedavisi", "Akne Bakımı", "Nemlendirme"],
  },
  "kafa-masaji": {
    title: "Kafa Masajı",
    seoTitle: "Bursa Kafa Masajı | Rahatlatıcı Terapi | Purevia Güzellik",
    heroImage: "https://images.unsplash.com/photo-1706795034830-de41aee06afa?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Rahatlatıcı kafa masajı ile stresi azaltın, kan dolaşımını artırın ve kendinizi yenileyin. Bursa'da profesyonel kafa masajı hizmeti.",
    longDescription: "Kafa masajı, günlük stresin etkilerini azaltmanın en etkili yollarından biridir. Uzman terapistlerimiz, özel tekniklerle uygulanan kafa masajı ile baş ağrılarını hafifletir, kan dolaşımını artırır ve genel bir rahatlama hissi sağlar. Saç sağlığını destekleyen bu terapi, düzenli uygulandığında saç dökülmesini azaltmaya da yardımcı olabilir.",
    benefits: [
      "Stres ve gerginlik azaltma",
      "Baş ağrısı ve migren rahatlama",
      "Kan dolaşımını artırma",
      "Saç sağlığını destekleme",
      "Uyku kalitesini iyileştirme",
      "Genel rahatlama ve yenilenme",
    ],
    areas: ["Klasik Kafa Masajı", "Hint Kafa Masajı", "Aromaterapi Masajı", "Refleksoloji"],
  },
  "masaj-hizmetleri": {
    title: "Masaj Hizmetleri",
    seoTitle: "Bursa Masaj Hizmetleri | Spa Masaj | Purevia Güzellik",
    heroImage: "https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Spa kalitesinde profesyonel masaj hizmetleri ile bedeninizi ve zihninizi dinlendirin. Bursa'da rahatlatıcı masaj terapileri.",
    longDescription: "Purevia Güzellik'te sunduğumuz masaj hizmetleri, spa kalitesinde rahatlatıcı bir deneyim sunar. Uzman terapistlerimiz, kas gerginliğini çözen, kan dolaşımını artıran ve genel sağlığınızı destekleyen çeşitli masaj teknikleri uygular. Huzurlu ortamımızda kendinizi tamamen bırakın ve yenilenin.",
    benefits: [
      "Kas gerginliğini çözme",
      "Kan dolaşımını artırma",
      "Stres ve anksiyete azaltma",
      "Esneklik ve hareket açıklığı artırma",
      "Uyku kalitesini iyileştirme",
      "Genel sağlık ve zindelik",
    ],
    areas: ["İsveç Masajı", "Derin Doku Masajı", "Aromaterapi", "Sıcak Taş Masajı", "Bölgesel Masaj"],
  },
  "protez-tirnak": {
    title: "Protez Tırnak",
    seoTitle: "Bursa Protez Tırnak | Profesyonel Tırnak Tasarımı | Purevia Güzellik",
    heroImage: "https://images.unsplash.com/photo-1648844421753-351afd50486a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
    description: "Estetik ve uzun ömürlü protez tırnak uygulamaları ile elleriniz her zaman bakımlı ve şık görünsün. Bursa protez tırnak uzmanı.",
    longDescription: "Protez tırnak uygulamalarımız, doğal görünümlü ve dayanıklı sonuçlar sunar. Jel, akrilik ve polygel teknikleriyle istediğiniz tırnak şeklini ve uzunluğunu elde edebilirsiniz. Uzman nail artistlerimiz, her müşterinin tarzına uygun özgün tasarımlar oluşturur.",
    benefits: [
      "Doğal görünümlü ve dayanıklı sonuçlar",
      "Jel, akrilik ve polygel seçenekleri",
      "Kişiye özel tırnak tasarımları",
      "Uzun ömürlü ve kırılmaya dayanıklı",
      "Hijyenik uygulama ortamı",
      "Trend tırnak sanatı ve süslemeleri",
    ],
    areas: ["Jel Protez", "Akrilik Protez", "Polygel", "French Tırnak", "Tırnak Süsleme", "Onarım"],
  },
  "manikur-pedikur": {
    title: "Manikür & Pedikür",
    seoTitle: "Bursa Manikür Pedikür | Profesyonel Tırnak Bakımı | Purevia Güzellik",
    heroImage: "https://images.pexels.com/photos/18227812/pexels-photo-18227812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Hijyenik ortamda profesyonel manikür ve pedikür bakımı ile el ve ayaklarınıza hak ettiği özeni gösterin. Bursa manikür pedikür.",
    longDescription: "El ve ayak bakımı, kişisel bakımın vazgeçilmez bir parçasıdır. Purevia Güzellik'te hijyenik ortamda, sterilize edilmiş araçlarla profesyonel manikür ve pedikür hizmeti sunuyoruz. Tırnak şekillendirme, kütikül bakımı, peeling ve nemlendirme gibi kapsamlı bakım protokollerimizle el ve ayaklarınız her zaman bakımlı görünür.",
    benefits: [
      "Tam sterilizasyon ve hijyen garantisi",
      "Kapsamlı el ve ayak bakımı",
      "Tırnak şekillendirme ve kütikül bakımı",
      "Peeling ve nemlendirme uygulamaları",
      "Kalıcı oje ve jel oje seçenekleri",
      "Rahatlatıcı masaj ile bakım",
    ],
    areas: ["Klasik Manikür", "Jel Manikür", "Spa Pedikür", "Medikal Pedikür", "Kalıcı Oje", "Tırnak Bakımı"],
  },
};

export default function ServiceDetailPage() {
  const { serviceId } = useParams();
  const service = servicesData[serviceId];

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-black mb-4">Sayfa Bulunamadı</h1>
          <Link to="/" className="text-sm font-semibold uppercase tracking-widest text-black hover:text-[#A66C6C] transition-colors">
            Ana Sayfaya Dön
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[400px] overflow-hidden">
        <img
          src={service.heroImage}
          alt={service.seoTitle}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute inset-0 flex items-end">
          <div className="max-w-7xl mx-auto px-6 md:px-12 w-full pb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Link
                to="/"
                data-testid="service-back-link"
                className="inline-flex items-center gap-2 text-white/80 hover:text-white text-sm mb-4 transition-colors"
              >
                <ArrowLeft size={16} />
                Ana Sayfa
              </Link>
              <h1
                data-testid="service-detail-title"
                className="text-4xl sm:text-5xl font-bold tracking-tighter text-white"
              >
                {service.title}
              </h1>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
            {/* Main Content */}
            <div className="lg:col-span-2">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <p className="text-lg font-medium text-black leading-relaxed mb-6">
                  {service.description}
                </p>
                <p className="text-base text-black/70 leading-relaxed mb-10">
                  {service.longDescription}
                </p>

                {/* Benefits */}
                <h2 className="text-2xl font-bold tracking-tight text-black mb-6">
                  Neden Purevia?
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
                  {service.benefits.map((benefit, i) => (
                    <div key={i} className="flex items-start gap-3" data-testid={`benefit-${i}`}>
                      <CheckCircle size={18} className="text-[#A66C6C] flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-black/70">{benefit}</span>
                    </div>
                  ))}
                </div>

                {/* Service Areas */}
                <h2 className="text-2xl font-bold tracking-tight text-black mb-6">
                  Uygulama Alanları
                </h2>
                <div className="flex flex-wrap gap-3">
                  {service.areas.map((area, i) => (
                    <span
                      key={i}
                      className="px-5 py-2.5 border border-[#EBEBEB] text-sm font-medium text-black/80 hover:border-[#A66C6C] hover:text-[#A66C6C] transition-colors duration-300"
                    >
                      {area}
                    </span>
                  ))}
                </div>
              </motion.div>
            </div>

            {/* Sidebar CTA */}
            <div className="lg:col-span-1">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="sticky top-28 bg-[#FAFAFA] border border-[#EBEBEB] p-8"
              >
                <h3 className="text-lg font-bold text-black mb-2">Randevu Alın</h3>
                <p className="text-sm text-black/60 mb-6">
                  {service.title} hizmetimiz hakkında bilgi almak ve randevu oluşturmak için bize ulaşın.
                </p>
                <div className="space-y-3">
                  <a
                    href={`https://wa.me/905441199544?text=Merhaba%2C%20${encodeURIComponent(service.title)}%20hakkında%20bilgi%20almak%20istiyorum.`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="service-detail-whatsapp"
                    className="flex items-center justify-center gap-2 w-full bg-black text-white hover:bg-gray-900 transition-colors duration-300 py-4 uppercase tracking-widest text-xs font-semibold"
                  >
                    <MessageCircle size={16} />
                    WhatsApp ile Randevu
                  </a>
                  <a
                    href="tel:+905441199544"
                    data-testid="service-detail-phone"
                    className="flex items-center justify-center gap-2 w-full border border-black text-black hover:bg-black hover:text-white transition-colors duration-300 py-4 uppercase tracking-widest text-xs font-semibold"
                  >
                    <Phone size={16} />
                    0544 119 95 44
                  </a>
                </div>

                <div className="mt-8 pt-6 border-t border-[#EBEBEB]">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] gold-text mb-3">
                    İlk Randevu Fırsatı
                  </p>
                  <p className="text-sm text-black/70">
                    <span className="font-bold text-black">PUREVIA25</span> koduyla ilk randevunuzda %25 indirim!
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tighter text-white mb-4">
            Hemen Randevu Alın
          </h2>
          <p className="text-sm text-white/60 mb-8">Kendinize hak ettiğiniz bakımı sunun</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="https://wa.me/905441199544"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gold-bg text-black hover:opacity-90 transition-opacity duration-300 px-8 py-4 uppercase tracking-widest text-xs font-semibold"
            >
              Randevu Al
            </a>
            <Link
              to="/"
              className="inline-flex items-center justify-center border border-white/30 text-white hover:bg-white/10 transition-colors duration-300 px-8 py-4 uppercase tracking-widest text-xs font-semibold"
            >
              Tüm Hizmetler
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
